"use client";

import { ArrowUpDown } from "lucide-react";
import { cn } from "@repo/ui/lib/utils";
import { Label } from "./label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "./select";

export interface ListSortOption {
  value: string;
  label: string;
}

interface ListSortSelectProps {
  id: string;
  value: string;
  options: ListSortOption[];
  onValueChange: (value: string) => void;
  label?: string;
  className?: string;
}

export function ListSortSelect({
  id,
  value,
  options,
  onValueChange,
  label = "Trier par",
  className,
}: ListSortSelectProps) {
  return (
    <div
      className={cn(
        "inline-flex items-stretch overflow-hidden rounded-lg border border-input bg-card shadow-sm",
        className
      )}
    >
      <div className="flex items-center gap-1.5 border-r border-input bg-muted/40 px-3 py-2">
        <ArrowUpDown className="h-3.5 w-3.5 text-muted-foreground" aria-hidden />
        <Label
          htmlFor={id}
          className="cursor-default text-xs font-medium text-muted-foreground whitespace-nowrap"
        >
          {label}
        </Label>
      </div>

      <Select value={value} onValueChange={onValueChange}>
        <SelectTrigger
          id={id}
          className="h-auto min-h-9 min-w-[150px] rounded-none border-0 bg-transparent px-3 py-2 text-sm font-medium shadow-none focus:ring-0 focus:ring-offset-0"
        >
          <SelectValue placeholder="Choisir…" />
        </SelectTrigger>
        <SelectContent align="end">
          {options.map((option) => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
